/**
 * The Confirm All gate (Spec #34102 AC2 / Business Rule 4, extended by AB#35149).
 *
 * Three conditions, all required:
 *
 *  1. no outstanding rows - nothing NeedsEntry or unacknowledged-LowConfidence;
 *  2. patient and requestor confirmed (Business Rule 3, real F1c match state);
 *  3. no Request Type/Purpose sync in flight.
 *
 * Condition 3 is the new one. Confirming a Type/Purpose change fires a backend round-trip that can
 * reset another row - Records Requested, when the new purpose offers a different record-type set.
 * The round-trip is asynchronous, so until it lands the screen still shows the OLD, confirmed rows
 * while the outstanding count reads zero. A specialist moving quickly could commit the whole
 * request in that window, confirming values that were a moment from being replaced.
 *
 * The other half of the protection is not a rule here: when the sync lands and a row was actually
 * reset, that row goes back into the editing set, which AB#35073 downgrades to NeedsEntry. It then
 * counts as outstanding through condition 1, so the specialist has to look at the reloaded row and
 * confirm it before Confirm All returns. Reusing the outstanding count keeps the header's
 * "N need your attention" tally and this gate from ever disagreeing.
 */
export function isConfirmAllEnabled(
    outstandingCount: number,
    patientRequestorConfirmed: boolean,
    purposeSyncInFlight: boolean,
): boolean {
    return outstandingCount === 0 && patientRequestorConfirmed && !purposeSyncInFlight;
}

export default isConfirmAllEnabled;
